import Actions from 'actions';

const initialState = Object.freeze({});

function createPassword(state = initialState, action) {
  switch (action.type) {
    case Actions.CREATE_PASSWORD_REQUEST:
      return initialState;
    case Actions.CREATE_PASSWORD_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.CREATE_PASSWORD_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default createPassword;
